export const TERMINAL_OPPORTUNITY_STATUSES = new Set([
  'Closed Won',
  'Signed Contract',
  'Review Extranet Discount Added',
  'Lost',
  'Withdrawn',
]);

export const COUNTRIES = [
  { code: 'AU', name: 'Australia' },
  { code: 'IN', name: 'India' },
  { code: 'SG', name: 'Singapore' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'US', name: 'United States' },
  { code: 'DE', name: 'Germany' },
  { code: 'CN', name: 'China' },
  { code: 'HK', name: 'Hong Kong' },
];
